import { render, staticRenderFns } from "./AdminFamilias.vue?vue&type=template&id=2904f54a&"
import script from "./AdminFamilias.vue?vue&type=script&lang=js&"
export * from "./AdminFamilias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports